export class RockDueDateHistory {
    id!: string
    rockId!: string
    oldDueDate!: Date | null
    newDueDate!: Date | null
    changedOn!: Date
    changedById!: string
    changedByName!: string
}
